export class SoundEffects {
    private audioContext: AudioContext | null = null;

    constructor() {
        try {
            this.audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
        } catch (error) {
            console.warn('Audio context not supported:', error);
        }
    }

    playSuccessSound(): void {
        if (!this.audioContext) return;

        try {
            const frequencies = [523.25, 659.25, 783.99];
            let time = this.audioContext.currentTime;

            frequencies.forEach((freq, index) => {
                const osc = this.audioContext!.createOscillator();
                const gain = this.audioContext!.createGain();

                osc.connect(gain);
                gain.connect(this.audioContext!.destination);

                osc.frequency.setValueAtTime(freq, time + index * 0.1);
                osc.type = 'sine';

                gain.gain.setValueAtTime(0.3, time + index * 0.1);
                gain.gain.exponentialRampToValueAtTime(0.01, time + index * 0.1 + 0.2);

                osc.start(time + index * 0.1);
                osc.stop(time + index * 0.1 + 0.2);
            });
        } catch (error) {
            console.warn('Failed to play success sound:', error);
        }
    }

    playErrorSound(): void {
        if (!this.audioContext) return;

        try {
            const osc = this.audioContext.createOscillator();
            const gain = this.audioContext.createGain();

            osc.connect(gain);
            gain.connect(this.audioContext.destination);

            osc.frequency.setValueAtTime(200, this.audioContext.currentTime);
            osc.frequency.exponentialRampToValueAtTime(150, this.audioContext.currentTime + 0.3);
            osc.type = 'sawtooth';

            gain.gain.setValueAtTime(0.2, this.audioContext.currentTime);
            gain.gain.exponentialRampToValueAtTime(0.01, this.audioContext.currentTime + 0.3);

            osc.start();
            osc.stop(this.audioContext.currentTime + 0.3);
        } catch (error) {
            console.warn('Failed to play error sound:', error);
        }
    }

    playTypingSound(): void {
        if (!this.audioContext) return;

        try {
            const osc = this.audioContext.createOscillator();
            const gain = this.audioContext.createGain();

            osc.connect(gain);
            gain.connect(this.audioContext.destination);

            osc.frequency.setValueAtTime(800, this.audioContext.currentTime);
            osc.type = 'square';

            gain.gain.setValueAtTime(0.1, this.audioContext.currentTime);
            gain.gain.exponentialRampToValueAtTime(0.01, this.audioContext.currentTime + 0.05);

            osc.start();
            osc.stop(this.audioContext.currentTime + 0.05);
        } catch (error) {
            console.warn('Failed to play typing sound:', error);
        }
    }
}